import { FieldMappingTreeNode } from '../../../../../../utils/fieldMappingTreeBuilder';
import styles from '../components/TreeFieldMappingsTable.module.sass';

/**
 * Helper to get the appropriate CSS class for a field type badge
 */
export const getTypeBadgeClass = (type: string): string => {
  const typeMap: Record<string, string> = {
    string: styles.typeBadgeString,
    object: styles.typeBadgeObject,
    array: styles.typeBadgeArray,
    boolean: styles.typeBadgeBoolean,
    number: styles.typeBadgeNumber,
    integer: styles.typeBadgeNumber,
  };
  return typeMap[type.toLowerCase()] || styles.typeBadgeDefault;
};

/**
 * Helper to format the type label for display
 * For arrays of primitives, shows "array[type]"
 */
export const getTypeLabel = (node: FieldMappingTreeNode): string => {
  if (node.type === 'array' && node.arrayItemType) {
    return `array [${node.arrayItemType}]`;
  }
  return node.type;
};
